import React from 'react'

import styles from './styles.module.scss'
import develop from "../../../../images/main/develop.jpg";
import develop480 from "../../../../images/main/develop_480.jpg";

const OurProduction = () => {
  const [activeBlock, setActiveBlock] = React.useState('')
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.title}>Наши лучшие разработки</p>
        <div className={styles.list}>
          <div className={styles.item}>
            <p className={styles.number}>19</p>
            <p className={styles.text_lg}>
              лекарственных препаратов <br />и средств диагностики
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>30+</p>
            <p className={styles.text_lg}>
              препаратов на разных <br />стадиях разработки
            </p>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>
            Продукты
          </p>
          <div className={styles.fbk1}>
            <div className={styles.cell1}>
              <p className={styles.title_p1}>
                Компания специализируется на исследовании и разработке лекарственных и диагностических препаратов, а также изделий медицинского назначения для диагностики <i>in vitro</i> в таких областях как: онкология, гематология, туберкулез, нейродегенеративные заболевания, орфанные (наследственные) заболевания, аутоиммунные заболевания.
              </p>
              <p className={styles.title_p2}>
                Ознакомиться с информацией о наших продуктах вы можете, перейдя по ссылке.
              </p>
            </div>
            <div className={styles.cell2}>
              <a href="https://www.generium.ru/products/" target="_blank" className={styles.button}>
                Все продукты <span>&rarr;</span>
              </a>
            </div>
          </div>
          <img src={develop} alt='search' className={styles.develop} draggable='false' />
          <img src={develop480} alt='search' className={styles.develop_480} draggable='false' />
        </div>
      </div>
    </div>
  )
}

export default OurProduction
